module.exports = __webpack_public_path__ + "img/77.1.a1eddd58.jpg";